<div class="control-bar text-right">
    <slot/>
</div>